export const API_ENDPOINTS = {
  LOGIN: "/login",
  REFRESH: "/refresh",
  GROUP: "/member/group",
  COURT_ORDER_DEPENDENTS: "/claims/getCourtOrderedMembers",
  MAGIC_LINK: "/magic/magicLink",
  CARE_HISTORY: {
    CONFIG: "/claims/configData",
    GRAPH: "/claims/stats",
    CLAIMS: "/claims/history",
    EOB: "/member/eobCard",
    EXPORT: "/claims/careHistoryExport",
  },
  ID_CARD: "/member/idCard",
  DATA_ACCESS: {
    CONFIG: "/config",
    AUTHORIZATION_ACCESS: "/authorizationAccess",
  },
  PROVIDER_SEARCH: {
    SETTINGS: "/provider/getProviderSettingsByGroup",
    FREETEXT_SEARCH: "/provider/freeTextProviderSearch",
    FREETEXT_SEARCH_VIEW_MORE: "/provider/searchByProvider",
    SEARCH: "/provider/providerSearch",
  },
  HCBB: {
    SEARCH: "/providers/v3/search",
    ESTIMATE: "/providers/v3/estimate",
    PROFESSIONALS: "/providers/v3/professionals",
    PROVIDER_ESTIMATES: "/providers/v3/provider-estimates",
    RECENT_SEARCH: "/providers/v3/recent-searches",
  },
  CHATBOT: {
    DEFAULT_QUERIES: "/chatbot/botDefaultQueries",
    MEMBER_SPECIFIC: "/chatbot/memberSpecificResponse",
  },
  BALANCE_BILL: {
    UPLOAD_BILL: "/balance-billing/create-ticket",
    LIST_ALL_BILLS: "/balance-billing/tickets",
    SINGLE_BILL_INFO: "/balance-billing/ticket-details",
    SINGLE_BILL_ATTACHMENT: "/balance-billing/attachments/content",
  },
  FEATURE_IMAGES: "/member/sliderImages",
  LOCATION: {
    GEOCODE: "/googleApi/getGeoCode",
    LAT_LONG: "/googleApi/getLatLong",
    PREDICTIONS: "/googleApi/getLocation",
  },
  COVERAGE_CERTIFICATE: "/member/coverageDocument",
  REQUEST_ID_CARD: "/member/idCardRequest",
  UI_LABELS: "/applicationConfiguration/uiLabels",
  PAPERLESS_EOB: {
    FETCH: "/member/paperless-eob/status",
    UPDATE: "/member/paperless-eob/update",
  },
  TAX_FORM: {
    FETCH: "/member/memberDocument",
  },
  RATING: "/application/rating",
  LOGS: "/application/logger",
  NOTIFICATION: {
    LIST: "/notification/getNotifications",
    UPDATE_STATUS: "/notification/toggleNotificationFlag",
  },
  RECOMMENDATION: {
    LIST: "/notification/recommendation",
    UPDATE_STATUS: "/notification/toggleRecommendation",
  },
  INVITE_USER: "/member/invite",
  VIDEOS: {
    LIST: "/home/appGroupSpecificVideos",
  },
};

export const CHATBOT_ENDPOINT = "https://chatbot.zakipointhealth.com/search";

export enum ENDPOINT {
  ID_CARD = "https://api.zakipointhealth.com/api/member/idCard",
}

export enum API_STATUS_MESSAGE {
  SUCCESS = "success",
  FAILURE = "failure",
  BLOCKED = "blocked",
}
